import React, { useState } from "react";
import "./styles.css";
import { ReactComponent as EyeIcon } from "../../../assets/icons/eye.svg";
import { ReactComponent as EyeSlashIcon } from "../../../assets/icons/eye-slash.svg";

export const UncontrolledInput = ({
                                      error,
                                      errorMessage,
                                      register,
                                      name,
                                      type,
                                      placeholder,
                                      label,
                                  }) => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const isPassword = type === "password";
    const isNumber = type === "number";

    const inputIcon = passwordVisible ? (
        <EyeSlashIcon width="100%" height="100%" stroke="#818c99" />
    ) : (
        <EyeIcon width="100%" height="100%" stroke="#818c99" />
    );

    // Используем объект register напрямую
    const registerProps = register ? { ...register } : {};

    return (
        <>
            {label && <div className="input_label">{label}</div>}
            <div className="input_container">
                <input
                    className={"input_main" + (error ? " input_error" : "")}
                    name={name}
                    type={passwordVisible ? "text" : type}
                    placeholder={placeholder}
                    {...registerProps}
                />
                {isPassword && (
                    <div
                        className="input_icon"
                        onClick={() => setPasswordVisible(!passwordVisible)}
                    >
                        {inputIcon}
                    </div>
                )}
            </div>
            {errorMessage && (
                <div className="input_error-message">{errorMessage}</div>
            )}
        </>
    );
};
